export default {
  // Двс
  'ДВС под нагрузкой, заглох при движении': [2], // t1_enginestalledspdcntg
  'ДВС >2400 об/мин.': [4], // t1_excessrpm
  'При переключении МКПП ДВС <800 об/мин.': [5], // t1_gearshiftrpm
  'ДВС >1900 об/мин. без применения моторного тормоза': [20], // t1_ineffectiverpmwithnomotobrake
  'При движении ДВС <550 об/мин.': [33, 34], // t1_rpmspdless440cntg
  'Повышенные обороты ДВС при начале движения: МКПП > 1200 об/мин, АКПП>1400 об/мин.': [35], // t1_rpmstartspdmore1200cnt

  // Трансмиссия
  'Начало движения, пережег сцепл., темп. дисков >100 градусов': [8, 9], // t1_slipping
  'Вкл./выкл блок мостов/колес при >7км/ч. или газ >0': [10], // t1_switchlock
  'Вкл./выкл пониженной РКП при >0 км/ч. или газ >0': [11], // t1_switchlower
  'Движение с вкл. межколесной блокировкой при >10 км/ч.': [12, 42], // t1_movelockcrosswheel
  'Начало движения, правильный выбор передачи в КПП': [13, 14, 15], // t1_rightgearforstart
  'МКПП: движение накатом на нейтральной передаче КПП': [18], // t1_rollforwardneutral
  'МКПП: движение с нажатой педалью сцепления': [19], // t1_moveclutchopen
  'Начало движения, переключение КПП с переднего на задний ход при > 0 км/ч.': [40], // t1_swithgearboxrewersspdcnt
  'Начало движения, лишняя работа сцепления': [43], // t1_clutchslipstart
  'Температура масла ретардера 130 и более градусов': [80, 81], // t1_retarderhitmpr
  'Работа дифференциалов мостов/колес при 0 км/ч.': [66, 67, 68, 69, 70, 71, 72, 73, 74, 75], // t1_difftransmoverload

  // КОМ
  'Крен при работе COM > 5 градусов': [16], // t1_ptoKrenUnload
  'Обороты ДВС >1000 или <800 при работе COM': [17], // t1_ptoRpmViolation
  'Движение с включенным COM': [27, 28, 29, 30], // t1_ptoSpdDistanceG
  'Движение с поднятым кузовом': [78, 79] // t1_backraisedspddistance
};
